import TokenService from '@/services/storage.service.js';
import router from '@/router';

// import router from "./router";

const $tokenService = new TokenService();

const getDefaultState = () => {
    return {
        authenticated: false,
        token: null,
        // emailVerified: false,
    };
};

const Auth = {
    namespaced: true,

    state: getDefaultState(),

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },

        UNSET_TOKEN: state => {
            $tokenService.removeToken();
            state.token = null;
        },

        UNSET_ACTIVE_ACCOUNT: () => {
            localStorage.removeItem('activeAccount');
        },

        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        auth: async ({ commit, dispatch }) => {
            if (!$tokenService.getToken()) return;
            Vue.prototype.$apiService.setBearer();
            Vue.prototype.$apiService.mountInterceptor401();
            commit('SET_TOKEN', $tokenService.getToken());

            try {
                await dispatch('User/fetchUser', null, { root: true });
                return true;
            } catch (error) {
                return false;
            }
        },

        login: ({ dispatch }, payload) => {
            return Vue.prototype.$apiService
                .post('login', payload)
                .then(async response => {
                    return await dispatch('processLoginResponse', response);
                })
                .catch(err => {
                    return 'incorrect';
                });
        },

        processLoginResponse: async ({ commit, dispatch, rootState }, response) => {
            if (!response.data.token) return;

            await dispatch('User/store', {
                email: response.data.user_email,
                niceName: response.data.user_nicename,
                displayName: response.data.user_display_name
            }, { root: true });

            $tokenService.saveToken(response.data.token);
            Vue.prototype.$apiService.setBearer();
            Vue.prototype.$apiService.mountInterceptor401();

            commit('SET_TOKEN', response.data.token);
            await dispatch('User/fetchUser', null, { root: true });
            router.push({ name: 'app' });
        },

        signout: ({ dispatch }, redirect = true) => {
            dispatch('resetAll', null, { root: true });
            if (redirect) {
                router.push({ name: 'login' });
                setTimeout(() => {
                    router.go();
                }, 100);
            }
        },

        resetState: ({ commit }) => {
            commit('UNSET_TOKEN');
            commit('UNSET_ACTIVE_ACCOUNT');
            commit('RESET_STATE');
        },

        unsetActiveAccount: ({ commit }) => {
            commit('UNSET_ACTIVE_ACCOUNT');
        },
    },
    getters: {},
};

export default Auth;
